<template>
    <button class="switch" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" width="62" height="30" viewBox="0 0 62 30">
            <g fill="none" fill-rule="evenodd">
                <path fill="#979797" d="M0,15 C0,6.71572875 6.71572875,1.77635684e-15 15,0 L47,0 C52.3589839,-7.98550843e-08 57.3108893,2.85898375 59.9903812,7.49999994 C62.6698732,12.1410161 62.6698732,17.8589839 59.9903812,22.5000001 C57.3108893,27.1410162 52.3589839,30.0000001 47,30 L15,30 C6.71572875,30 0,23.2842712 0,15 Z"/>
                <circle cx="47" cy="15" r="12" fill="#FFF" fill-rule="nonzero" :class="{ inactive: !on }"/>
            </g>
        </svg>
    </button>
</template>

<script>
    export default {
        name: "SwitchButton",
        props: {
            on: {
                type: Boolean,
                default: true
            }
        }
    }
</script>

<style scoped>

</style>